<ng-container *ngIf="smsCardData$ | async as smsCardData">
  <mat-card appearance="outlined">
    <mat-card-header>
      <img mat-card-avatar [src]="getLogoImage()" alt="avatar" />
      <mat-card-title class="title"> {{ 'SMS_REGISTRATION.CARD.YOUR_SMS_NUMBER' | translate }}</mat-card-title>
      <div class="badge">
        <glxy-badge [color]="smsCardData.statusBadgeColor">
          {{ smsCardData.statusBadgeText }}
        </glxy-badge>
      </div>
    </mat-card-header>
    <mat-card-content class="content-container">
      <div class="content-title">
        <div class="phone-number-container">
          <p>Assigned number: {{ (smsNumber$ | async) || '-' }}</p>
          <button mat-icon-button cdkOverlayOrigin #popoverOrigin="cdkOverlayOrigin" (click)="toggleInfoPopover()">
            <mat-icon>info_outline</mat-icon>
          </button>
          <glxy-popover
            [isOpen]="showPopover"
            [hasBackdrop]="true"
            [showBackdrop]="true"
            [hasArrow]="true"
            (backdropClick)="closeInfoPopover()"
            [origin]="popoverOrigin"
          >
            <glxy-popover-title>Assigned number</glxy-popover-title>
            <div>
              <p>{{ 'SMS_REGISTRATION.CARD.ASSIGNED_NUMBER_DESCRIPTION' | translate }}</p>
            </div>
            <glxy-popover-actions>
              <button mat-stroked-button color="primary" (click)="closeInfoPopover()">Close</button>
            </glxy-popover-actions>
          </glxy-popover>
        </div>
      </div>
      <ng-container *ngIf="(country$ | async) === 'US'">
        <div class="content-title">
          <div>{{ smsCardData.title }}</div>
        </div>
        <div class="description">
          {{ smsCardData.content }}
          <a (click)="openLearnMoreModal()">Learn more</a>
        </div>
        <div *ngIf="smsCardData.statusBadgeText !== 'Active'">
          <button mat-raised-button color="{{ smsCardData.buttonType }}" (click)="redirectToSMSRegistration()">
            {{ smsCardData.buttonText }}
          </button>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</ng-container>
